import { apiGet, apiPost } from "../core/request";

export type FxAccount = {
  id: number;
  label?: string | null;
  currency: string;
  balance: number;
  available_balance?: number;
};

export type FxQuote = {
  ok: boolean;
  from_currency: string;
  to_currency: string;
  from_amount: number;
  base_rate: number;
  rate: number;
  fee_markup_percent: number;
  converted_amount: number;
  fee: number;
};

export async function apiFxIndex() {
  return apiGet<{
    accounts: FxAccount[];
    from_currencies: string[];
    to_currencies: string[];
  }>("/xapi/fx");
}

export async function apiFxQuote(payload: {
  from_currency: string;
  to_currency: string;
  from_amount: number;
}) {
  return apiPost<FxQuote>("/xapi/fx/quote", payload);
}

export async function apiFxStore(payload: {
  from_currency: string;
  to_currency: string;
  from_amount: number;
}) {
  return apiPost<{ ok: boolean; fx: any; redirect?: string }>("/xapi/fx", payload);
}
